/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SecurityInitiativeDto } from './SecurityInitiativeDto';
import {
    SecurityInitiativeDtoFromJSON,
    SecurityInitiativeDtoFromJSONTyped,
    SecurityInitiativeDtoToJSON,
    SecurityInitiativeDtoToJSONTyped,
} from './SecurityInitiativeDto';
import type { InitiativeMilestoneDto } from './InitiativeMilestoneDto';
import {
    InitiativeMilestoneDtoFromJSON,
    InitiativeMilestoneDtoFromJSONTyped,
    InitiativeMilestoneDtoToJSON,
    InitiativeMilestoneDtoToJSONTyped,
} from './InitiativeMilestoneDto';
import type { OnboardingStateDto } from './OnboardingStateDto';
import {
    OnboardingStateDtoFromJSON,
    OnboardingStateDtoFromJSONTyped,
    OnboardingStateDtoToJSON,
    OnboardingStateDtoToJSONTyped,
} from './OnboardingStateDto';
import type { FrameworkCoverageDto } from './FrameworkCoverageDto';
import {
    FrameworkCoverageDtoFromJSON,
    FrameworkCoverageDtoFromJSONTyped,
    FrameworkCoverageDtoToJSON,
    FrameworkCoverageDtoToJSONTyped,
} from './FrameworkCoverageDto';

/**
 * 
 * @export
 * @interface ProgramDashboardDto
 */
export interface ProgramDashboardDto {
    /**
     * 
     * @type {number}
     * @memberof ProgramDashboardDto
     */
    healthScore?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramDashboardDto
     */
    healthScoreDelta?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramDashboardDto
     */
    coveredControls?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramDashboardDto
     */
    totalControls?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramDashboardDto
     */
    coveragePct?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramDashboardDto
     */
    avgMaturity?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramDashboardDto
     */
    activeInitiatives?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramDashboardDto
     */
    atRiskInitiatives?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramDashboardDto
     */
    completedInitiatives?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramDashboardDto
     */
    totalInitiatives?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramDashboardDto
     */
    totalBudgetAllocated?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramDashboardDto
     */
    totalBudgetSpent?: number;
    /**
     * 
     * @type {Array<SecurityInitiativeDto>}
     * @memberof ProgramDashboardDto
     */
    initiatives?: Array<SecurityInitiativeDto>;
    /**
     * 
     * @type {Array<InitiativeMilestoneDto>}
     * @memberof ProgramDashboardDto
     */
    upcomingMilestones?: Array<InitiativeMilestoneDto>;
    /**
     * 
     * @type {{ [key: string]: FrameworkCoverageDto; }}
     * @memberof ProgramDashboardDto
     */
    frameworkCoverage?: { [key: string]: FrameworkCoverageDto; };
    /**
     * 
     * @type {OnboardingStateDto}
     * @memberof ProgramDashboardDto
     */
    onboardingState?: OnboardingStateDto;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramDashboardDto
     */
    hasChildTenants?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramDashboardDto
     */
    firstSnapshot?: boolean;
}

/**
 * Check if a given object implements the ProgramDashboardDto interface.
 */
export function instanceOfProgramDashboardDto(value: object): value is ProgramDashboardDto {
    return true;
}

export function ProgramDashboardDtoFromJSON(json: any): ProgramDashboardDto {
    return ProgramDashboardDtoFromJSONTyped(json, false);
}

export function ProgramDashboardDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramDashboardDto {
    if (json == null) {
        return json;
    }
    return {
        
        'healthScore': json['healthScore'] == null ? undefined : json['healthScore'],
        'healthScoreDelta': json['healthScoreDelta'] == null ? undefined : json['healthScoreDelta'],
        'coveredControls': json['coveredControls'] == null ? undefined : json['coveredControls'],
        'totalControls': json['totalControls'] == null ? undefined : json['totalControls'],
        'coveragePct': json['coveragePct'] == null ? undefined : json['coveragePct'],
        'avgMaturity': json['avgMaturity'] == null ? undefined : json['avgMaturity'],
        'activeInitiatives': json['activeInitiatives'] == null ? undefined : json['activeInitiatives'],
        'atRiskInitiatives': json['atRiskInitiatives'] == null ? undefined : json['atRiskInitiatives'],
        'completedInitiatives': json['completedInitiatives'] == null ? undefined : json['completedInitiatives'],
        'totalInitiatives': json['totalInitiatives'] == null ? undefined : json['totalInitiatives'],
        'totalBudgetAllocated': json['totalBudgetAllocated'] == null ? undefined : json['totalBudgetAllocated'],
        'totalBudgetSpent': json['totalBudgetSpent'] == null ? undefined : json['totalBudgetSpent'],
        'initiatives': json['initiatives'] == null ? undefined : ((json['initiatives'] as Array<any>).map(SecurityInitiativeDtoFromJSON)),
        'upcomingMilestones': json['upcomingMilestones'] == null ? undefined : ((json['upcomingMilestones'] as Array<any>).map(InitiativeMilestoneDtoFromJSON)),
        'frameworkCoverage': json['frameworkCoverage'] == null ? undefined : (mapValues(json['frameworkCoverage'], FrameworkCoverageDtoFromJSON)),
        'onboardingState': json['onboardingState'] == null ? undefined : OnboardingStateDtoFromJSON(json['onboardingState']),
        'hasChildTenants': json['hasChildTenants'] == null ? undefined : json['hasChildTenants'],
        'firstSnapshot': json['firstSnapshot'] == null ? undefined : json['firstSnapshot'],
    };
}

export function ProgramDashboardDtoToJSON(json: any): ProgramDashboardDto {
    return ProgramDashboardDtoToJSONTyped(json, false);
}

export function ProgramDashboardDtoToJSONTyped(value?: ProgramDashboardDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'healthScore': value['healthScore'],
        'healthScoreDelta': value['healthScoreDelta'],
        'coveredControls': value['coveredControls'],
        'totalControls': value['totalControls'],
        'coveragePct': value['coveragePct'],
        'avgMaturity': value['avgMaturity'],
        'activeInitiatives': value['activeInitiatives'],
        'atRiskInitiatives': value['atRiskInitiatives'],
        'completedInitiatives': value['completedInitiatives'],
        'totalInitiatives': value['totalInitiatives'],
        'totalBudgetAllocated': value['totalBudgetAllocated'],
        'totalBudgetSpent': value['totalBudgetSpent'],
        'initiatives': value['initiatives'] == null ? undefined : ((value['initiatives'] as Array<any>).map(SecurityInitiativeDtoToJSON)),
        'upcomingMilestones': value['upcomingMilestones'] == null ? undefined : ((value['upcomingMilestones'] as Array<any>).map(InitiativeMilestoneDtoToJSON)),
        'frameworkCoverage': value['frameworkCoverage'] == null ? undefined : (mapValues(value['frameworkCoverage'], FrameworkCoverageDtoToJSON)),
        'onboardingState': OnboardingStateDtoToJSON(value['onboardingState']),
        'hasChildTenants': value['hasChildTenants'],
        'firstSnapshot': value['firstSnapshot'],
    };
}

